/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  addResultToPreviousSeatch helper
 */

import type { AutocompleteApiResult } from '@zcode/bizos'
import { localStorageSingleton } from '@zcode/nr-utils'
import { logger } from '../../../../logger'
import { getRawPreviousSearches } from './getPreviousSearches'

const addResultToPreviousSearches = (result: AutocompleteApiResult) => {
  if (!result || !('id' in result)) {
    return
  }
  if (!result?._data?.record_type) {
    logger.error('malformed autocomplete result', result)
    return
  }

  const resultObject = { ...result._data, is_previous_search: true as const }
  const { record_id: recordId } = resultObject

  const storageSearches = getRawPreviousSearches() || []
  const prevSearches = storageSearches.filter(
    (storageSearch) => storageSearch.record_id !== recordId
  )

  prevSearches.unshift(resultObject)

  if (prevSearches.length > 3) {
    prevSearches.pop()
  }
  localStorageSingleton.set('prevSearches', prevSearches)
}

export default addResultToPreviousSearches
